export default {
    appraisal: 'Évaluation',
    completed: 'Terminé',
    processing: "En attente d'évaluation",
    vAuto: {
        helperMessage: "Vous devez soumettre l'évaluation à vAuto pour obtenir les données du véhicule",
        submit: 'Soumettre à vAuto',
    },
};
